import {useQuery} from '@tanstack/react-query';
import {SearchService} from 'client';
import {getService} from 'utilities';

// The server ignores shorter queries: two letters start too many titles.
const MIN_QUERY_LENGTH = 3;
// One request serves both views: "All" shows the first few under people and
// teams, the Knowledge filter shows them all.
const KNOWLEDGE_RESULT_LIMIT = 8;

/** Knowledge articles and home links for global search (already debounced input). */
export const useKnowledgeSearch = ({input, enabled}: {input: string; enabled: boolean}) => {
  const query = input.trim();
  return useQuery({
    queryKey: ['search', 'knowledge', query],
    queryFn: () =>
      getService(SearchService).searchKnowledgeApiV1SearchKnowledgeGet(
        query,
        KNOWLEDGE_RESULT_LIMIT
      ),
    enabled: enabled && query.length >= MIN_QUERY_LENGTH,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
